var CM = CM || {};
CM.Tower = (function () {

	const ui = {
		settings: {
			positionTowerOnDesktop: "right", // left or right
			positionTowerOnMobile: "right", // left or right
			mainBtnIcon: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjUxMi4wMDAwMDBwdCIgaGVpZ2h0PSI1MTIuMDAwMDAwcHQiIHZpZXdCb3g9IjAgMCA1MTIuMDAwMDAwIDUxMi4wMDAwMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLDUxMi4wMDAwMDApIHNjYWxlKDAuMTAwMDAwLC0wLjEwMDAwMCkiIGZpbGw9IiNGRkZGRkYiIHN0cm9rZT0ibm9uZSI+PHBhdGggZD0iTTIzMTUgNDkzOSBjLTY2NiAtNTQgLTEyOTMgLTM0MyAtMTcyNCAtNzk1IC01MzcgLTU2MSAtNzIzIC0xMzE2IC00OTYgLTIwMDkgMTA4IC0zMjggMjgxIC02MDQgNTQ1IC04NjYgbDEzOCAtMTM2IC05OSAtMTMzIGMtMTE4IC0xNTggLTI1MCAtMzE2IC0zODQgLTQ1OCAtOTkgLTEwNiAtMTI1IC0xNDggLTEyNSAtMjAyIDAgLTc4IDY3IC0xNTQgMTQ1IC0xNjYgMjYgLTMgMTI0IC0xIDIxOCA1IDU2NSAzOSAxMDU3IDE3MSAxMzYyIDM2NiBsNTAgMzIgMTM1IC0yMyBjNTM3IC05MSAxMDk5IC0yNyAxNTk5IDE4MiAzNjYgMTU0IDcwNCAzOTkgOTQzIDY4NCA1MzYgNjM4IDY0NiAxNDU1IDI5NCAyMTc1IC00MzcgODkwIC0xNDkwIDE0MzUgLTI2MDEgMTM0NHogbS05OTQgLTE4ODkgYzE4NyAtNTggMzEwIC0yMzUgMjk2IC00MjkgLTE1IC0yMjMgLTE3NSAtMzgzIC0zOTggLTM5OCAtMjUzIC0xOCAtNDY0IDE5NCAtNDQ3IDQ0OSAyMCAyNzcgMjg1IDQ2MCA1NDkgMzc4eiBtMTQxMiAtMTcgYzMzMiAtMTU2IDMzNyAtNjA4IDggLTc3MSAtNzIgLTM2IC03OSAtMzcgLTE4MCAtMzcgLTEwMiAwIC0xMDkgMSAtMTgyIDM3IC0xMjUgNjEgLTIwNyAxNjYgLTIzNSAyOTkgLTQ1IDIxMiA3NSA0MTUgMjkxIDQ5MiAzNyAxMyA3MyAxNyAxNDAgMTQgNzYgLTIgMTAwIC04IDE1OCAtMzR6IG0xMzE5IDE3IGMxNzAgLTUyIDI4NCAtMTk5IDI5NiAtMzgyIDE2IC0yNTIgLTE5NiAtNDYzIC00NDcgLTQ0NSAtOTEgNyAtMTQzIDI0IC0yMTggNzQgLTE5NiAxMzAgLTI0MSA0MTYgLTk1IDYwOCAxMDUgMTM4IDI5NSAxOTcgNDY0IDE0NXoiPjwvcGF0aD48L2c+PC9zdmc+", // chat, mail, headset, question-mark, or custom background-image to icon (url to image or use base64 encoded image)
			showResponseTimePerChannel: true, // show response times per channel
			openTowerAutomaticallyOnDesktop: false, // open tower automatically on desktop after x seconds
			openTowerAutomaticallyOnMobile: false, // open tower automatically on mobile after x seconds
			durationOpeningTowerAutomatically: 5000, // duration in ms when the tower should be opened automatically
		},
		colors: {
			MainBg: "#000000",
			MainBgHover: "#000000",
			MainLinks: "#000000",
			MainTxt: "#ffffff",
			MainIcon: "#ffffff",
			ChannelsBg: "#000000",
			ChannelsBgHover: "#000000",
			OnlineIndicator: "#3FFD65",
			LabelsBg: "#000000",
			LabelsTxt: "#FFF",
		},
		languages: {
			"en": {
				channels: {
					messenger: {
						showChannel: false, // show channel in tower
						link: "", // required if showChannel is true - enter the link to messenger desktop app
						widgetTitle: "Messenger", // required if showChannel is true - title shown within the widget on desktop devices
						widgetText: "Scan this QR code with your phone or open the desktop app to start our chat.", // required if showChannel is true - text shown within the widget on desktop devices
						serviceHoursText: "Response time between 8:00 and 21:00 (Saturday 8:00 - 16:00 and Sunday closed)", // required if showChannel is true - text shown within the widget on desktop devices
						qrCode: '', // required if showChannel is true - qrcode shown within the widget on desktop devices
						responseTime: "", // required if showResponseTimePerChannel is true
					},
					whatsapp: {
						showChannel: true, // show channel in tower
						link: "https://api.whatsapp.com/send?phone=27645331167", // required if showChannel is true - enter the link to whatsapp web
						widgetTitle: "WhatsApp", // required if showChannel is true - title shown within the widget on desktop devices
						widgetText: "If you need assistance, advice or if you have any questions please feel free to reach out to us and our team will assist you.", // required if showChannel is true - text shown within the widget on desktop devices
						serviceHoursText: "Scan this QR code with your phone or open the desktop app to start our chat.", // required if showChannel is true - text shown within the widget on desktop devices
						qrCode: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAAHCAQAAAABUY/ToAAADkElEQVR4nO2cW2rsSgxFl44b+tOGDCBDqZ7ZGdOZgT2UHsCF8mfARvejVH4lhwuhc/vB1keTTnthGzaSSlKVOd+z4dc3QRApUqRIkSJFinw80sJOALOVj8FOmJUPM7uM9arLnZ9W5EOSyd3dMzDY2c26xu3STngPuOfGgcbd3X1P3uNpRT4kOYZ/sUv7YaSrWZFUcUvtVK6qruo29xT5GuTp8N1hxod3B8a3yZLPJ6P953jds72nyJ8jj9qw9KfDUgZLf2Zzxq784Iy3uqfI1yRbd+/LXxMM3WwMHdiFxr0fz24XwN2n291T5EuRg5mZdQDj2UnXs5NKJg32OwMwl2XZre4p8kXIEsvWhoczzqGS4X2C4f3D6iX7tshzvafInyMp6/W+9XA8qX51z+A94Yy8bydIORb43j/Xe4r8ObJqCCDVZCck5VNJgLZVoXZCGhK5tyKQVFTSVI8UzsZJGYDGi3yKg5KGRG4tnEzrXqMVbFZolKgW4iqhLUlDIje2qQ9Zup4AmomU3yZLPW7lh/7DAMNhNr/f04p8RBJfLKIVUNocS3oUvqmN0KZYJnJvIaAMURBagxfs8+wJlsarNCRysZo6N17WYEtSFP/L4Za0thf5N6v1oYnV+9SWfeNrVPOeRjm1yK9sTYWiIJRDKlu9ANDW9Zv8kMjPZNHLYGcv80MwW/2rWrqaeT9qfkjk0dZ8KJxRzXh2q7Hqmzwrlok8Wm1k1FSoB+ooSG2VLZ2zyJakIZFb29SpYzioeqRIgJZEydcemjQkcmOrNlj6Zbt6YtQda0CTHxJ5tFDE0m4tnfm8HfsIj0Ts8JCGRO6t5kMANMv0YrMJbVGirhm3cmqRezvWqb3WE3exrKn9D80PifxktWZYOxzRL+PYfd3NpUlDIjcWEsosLY26fSPVBVttn+0IaUjkjjTrGi9bOmjdzezsMFrsvKd1Z+goMrPLnZ9W5GORm/mhQ3U60qP8yS3JD4n8glzP/YgF/niibDcbOggHNZ6Ijzs/rciHJNOSFA31dBjvAbuUybN6cEPKs/YoijzYGsHW4k/81C47PHKzKSEplonc2adzP4YuA20GmE/O+DYZUE5v2O50fa73FPm/krO5X+txZ0M3G9CUMxuIU9Jufk+RT0xu9ijW4aBlDQbUja3L9sSs+pDIox36ZX5s1LchrnU6X/0ykTsz/+9rvjSdcS5SpEiRIkWKfBHyX9fIhIgKLSXtAAAAAElFTkSuQmCC',
						responseTime: "", // required if showResponseTimePerChannel is true
					},
					phone: {
						showChannel: true, // show channel in tower
						phoneNumber: "+27606419905", // required if showChannel is true - enter international phone number
						responseTime: "", // required if showResponseTimePerChannel is true
					},
					chatAndContactForm: {
						showChannel: true, // show channel in tower
						splitChatAndContactForm: true, // dynamically change button based on online presence or always show contact form
						responseTimeChat: "", // required if showResponseTimePerChannel is true
						responseTimeContactForm: "" // required if showResponseTimePerChannel is true
					},
				},
				customLinks: [
					// Duplicate or remove object below to add/remove custom buttons
					{
						label: "",
						iconUrl: '',
						link: ""
					}
				],
				labels: {
					responseWithin: "", // label is combined with channel's responseTime string
					openApp: "Open app", // label is used for the button to channel's link within the desktop widget
				}
			},
		}
	};

	// **************************************************************************************
	// ******************************* DO NOT EDIT CODE BELOW *******************************
	// **************************************************************************************
    let tower = {};
	
	tower.Init = function () {
		initTowerBtn();
	};
	
	let state = {
		language: null,
		livechat: {
			livechatPresence: false,
			chatAvatar: null,
			chatEmailAddress: null,
		},
		loading: true,
		rbnWidgetLoaded: false,
		checkLoadingState: null,
        isDesktop: false,
	};
    
	const towerBtnIcons = [
		{name: "chat", iconString: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.675 14.962L19.946 18.676C20.069 19.037 19.977 19.438 19.707 19.707C19.517 19.897 19.261 20 19 20C18.892 20 18.782 19.982 18.676 19.946L14.962 18.675C13.498 19.514 11.808 20 10 20C4.478 20 0 15.522 0 10C0 4.478 4.478 0 10 0C15.522 0 20 4.478 20 10C20 11.808 19.514 13.498 18.675 14.962ZM15.6096 16.7827L17.3931 17.3931L16.4896 14.753L16.9398 13.9676C17.6318 12.7599 18 11.4076 18 10C18 5.58257 14.4174 2 10 2C5.58257 2 2 5.58257 2 10C2 14.4174 5.58257 18 10 18C11.4076 18 12.7599 17.6318 13.9676 16.9398L14.753 16.4896L15.6096 16.7827ZM14 9H6C5.447 9 5 8.553 5 8C5 7.447 5.447 7 6 7H14C14.553 7 15 7.447 15 8C15 8.553 14.553 9 14 9ZM14 13H6C5.447 13 5 12.553 5 12C5 11.447 5.447 11 6 11H14C14.553 11 15 11.447 15 12C15 12.553 14.553 13 14 13Z" fill="currentColor"/></svg>'},
		{name: "mail", iconString: '<svg width="20" height="17" viewBox="0 0 20 17" fill="none"><g clip-path="url(#clip0_2_7)"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 0C18.2091 0 20 1.79428 20 4.00763V12.0229C20 14.2362 18.2091 16.0305 16 16.0305H4C1.79086 16.0305 0 14.2362 0 12.0229V4.00763C0 1.79428 1.79086 0 4 0H16ZM18.0002 4.56326C15.407 7.50604 12.743 9.01718 10 9.01718C7.25729 9.01718 4.59361 7.50638 2.00062 4.56425L2 12.0229C2 13.1296 2.89543 14.0267 4 14.0267H16C17.1046 14.0267 18 13.1296 18 12.0229L18.0002 4.56326ZM16 2.00382H4C3.54989 2.00382 3.13451 2.15279 2.8003 2.40421C5.28819 5.51207 7.69172 7.01336 10 7.01336C12.3143 7.01336 14.7244 5.50418 17.2191 2.37984L17.1997 2.40421C16.8655 2.15279 16.4501 2.00382 16 2.00382Z" fill="currentColor"/></g><defs><clipPath id="clip0_2_7"><rect width="20" height="16.0305" fill="transparent"/></clipPath></defs></svg>'},
		{name: "headset", iconString: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><g clip-path="url(#clip0_2_5)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.58974 7.05128C3.41763 7.05128 3.24836 7.0634 3.08272 7.08682C4.31609 4.09197 6.89287 2.5641 9.8718 2.5641C12.8453 2.5641 15.4181 4.08636 16.6541 7.07033C16.5318 7.05774 16.4077 7.05128 16.2821 7.05128C15.6449 7.05128 15.1282 7.56787 15.1282 8.20513V14.6154C15.1282 15.1917 15.5506 15.6692 16.1027 15.7554C15.3206 16.2812 14.4165 16.6704 13.44 16.8947C13.0879 16.4437 12.5394 16.1538 11.9231 16.1538C10.861 16.1538 10 17.0149 10 18.0769C10 19.139 10.861 20 11.9231 20C12.9187 20 13.7377 19.2433 13.8362 18.2737C15.8512 17.8254 17.5447 16.6073 18.5378 14.9721C19.3515 14.314 19.8718 13.3076 19.8718 12.1795V10.641C19.8718 9.26404 19.0965 8.06814 17.9586 7.46603C16.8878 3.14278 13.6436 0 9.80769 0C5.91956 0 2.63935 3.22894 1.61427 7.64327C0.641683 8.28549 0 9.38832 0 10.641V12.1795C0 14.1621 1.60719 15.7692 3.58974 15.7692C4.22699 15.7692 4.74359 15.2527 4.74359 14.6154V8.20513C4.74359 7.56787 4.22699 7.05128 3.58974 7.05128Z" fill="currentColor"/></g><defs><clipPath id="clip0_2_5"><rect width="19.8718" height="20" fill="white"/></clipPath></defs></svg>'},
		{name: "question-mark", iconString: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.5301 10.8247C11.0409 11.185 10.8888 11.4837 10.8888 12.2267C10.8888 13.207 10.0571 14 9.02893 14C8.00174 14 7.16905 13.2066 7.16905 12.2267C7.16905 9.86478 8.03729 8.76405 10.0539 7.48456C11.1345 6.79765 11.2804 6.60945 11.2804 5.69333C11.2804 4.28824 10.3456 3.55345 9.0399 3.54667C7.75723 3.54667 6.73618 4.26312 6.71991 5.71282C6.70876 6.68457 5.87931 7.46667 4.86007 7.46667C3.81379 7.45599 2.98907 6.65374 3.00011 5.67398C3.0385 2.25627 5.71459 0 9.02208 0C12.3496 0.0158738 15.0001 2.28676 15.0001 5.69333C15.0001 8.05482 14.1329 9.15457 12.1166 10.4355C11.791 10.6425 11.6662 10.7245 11.5301 10.8247ZM9.00011 20C7.89611 20 7.00011 19.106 7.00011 18C7.00011 16.894 7.89611 16 9.00011 16C10.1061 16 11.0001 16.894 11.0001 18C11.0001 19.106 10.1061 20 9.00011 20Z" fill="currentColor"/></svg>'},
	];
	const fn = {
		isDesktop: function() {
            if (window.innerWidth >= 768) {
                state.isDesktop = true;
            }
		},
		setupMainElements: function() {
			const mainWrapper = document.createElement('div');
			mainWrapper.setAttribute('id', "cm-tower");

			if (ui.settings.positionTowerOnDesktop === "left") {
				mainWrapper.classList.add(ui.settings.positionTowerOnDesktop);
			}

			if (ui.settings.positionTowerOnMobile === "left") {
				mainWrapper.classList.add('mobile-' + ui.settings.positionTowerOnMobile);
			}

			const towerButton = '<div id="cm-tower-wrapper" class="cm-tower-wrapper">\
									<input id="cm-tower-checkbox" type="checkbox" class="cm-tower-checkbox">\
									<label class="cm-tower-btn" id="cm-tower-btn" for="cm-tower-checkbox">\
										<span class="cm-tower-dot dot-1"></span>\
										<span class="cm-tower-dot dot-2"></span>\
										<span class="cm-tower-dot dot-3"></span>\
									</label>\
									<div id="cm-tower-btn-wrapper" class="cm-tower-channels"></div>\
								</div>';
			
			mainWrapper.innerHTML += towerButton;

			let icon = towerBtnIcons
				.filter(function(icon) {
					return icon.name === ui.settings.mainBtnIcon
				})
				.map(function(icon) {
					return icon.iconString
				});

			const btn = mainWrapper.querySelector('#cm-tower-btn');
			let iconHtml;

			if (icon.length > 0) {
				iconHtml = '<span class="cm-tower-icon">' + icon + '</span>';
			} else if (icon.length < 1 && ui.settings.mainBtnIcon) {
				iconHtml = '<span class="cm-tower-icon" style="background-image: url(' + ui.settings.mainBtnIcon + ')"></span>';
			} else {
				icon = towerBtnIcons[0].iconString;
				iconHtml = '<span class="cm-tower-icon">' + icon + '</span>';
			}

			btn.innerHTML += iconHtml;

			if (state.isDesktop) {
				const customChannelForm = 	'<div class="cm-custom-form-wrapper">\
												<div class="cm-custom-form-header"></div>\
												<div class="cm-custom-form-content"></div>\
											</div>';

				mainWrapper.innerHTML += customChannelForm;
				
			}

			document.body.appendChild(mainWrapper);
		},
		openCustomForm(title, qrcode, text, serviceHoursText, url, backgroundColor) {
			const customForm = document.getElementsByClassName("cm-custom-form-wrapper")[0];
			const customFormHeader = document.getElementsByClassName("cm-custom-form-header")[0];
			const customFormContent = document.getElementsByClassName("cm-custom-form-content")[0];
			customFormHeader.innerHTML = '';
			customFormContent.innerHTML = '';

			customFormHeader.innerHTML = '<div class="cm-custom-form-title">' + title + '</div>';
			customFormContent.innerHTML += '<div class="cm-custom-form-actions"><div class="cm-custom-form-qrcode" style="background-image: url(' + qrcode + ')"></div><a class="cm-custom-form-btn" href="' + url + '" target="_blank">' + ui.languages[state.language].labels.openApp + '</a></div>';
			customFormContent.innerHTML += '<div class="cm-custom-form-text"><div class="top">' + text + '</div><div class="bottom">' + serviceHoursText + '</div></div>';
			customFormHeader.style.backgroundColor = backgroundColor;
			customForm.classList.add("show");
		},
		closeCustomForm() {
			const customForm = document.getElementsByClassName("cm-custom-form-wrapper")[0];
			customForm.classList.remove("show");
		},
		closeTower: function() {
			document.getElementById("cm-tower-checkbox").checked = false;
			fn.toggleOnlineIndicator();
		},
		addCloseWidgetButton: function(customForm) {
			let wrapper;
			const btn = document.createElement('div');
			btn.innerHTML = "<span class='cm-tower-dot dot-1'></span><span class='cm-tower-dot dot-2'></span><span class='cm-tower-dot dot-3'></span>";
			btn.addEventListener("click", function () {
				if (customForm === true) {
					fn.closeCustomForm();
				} else {
					__robin.hide();
				}
				fn.removeCloseWidgetButton();
			});
			if (state.isDesktop) {
				wrapper = document.getElementById("cm-tower-wrapper");
				btn.setAttribute('id', "cm-tower-custom-close-btn");
				btn.className = ('customCloseWidgetButton');
			} else {
				wrapper = document.getElementById("robin_popover");
				btn.setAttribute('id', "cm-tower-custom-close-btn");
				btn.className = ('customCloseWidgetButtonWidgetHeader');
			}
			wrapper.appendChild(btn);
		},
		removeCloseWidgetButton: function() {
			const closeBtn = document.getElementById("cm-tower-custom-close-btn");
			closeBtn.parentNode.removeChild(closeBtn);

			fn.toggleOnlineIndicator();
		},
		toggleOnlineIndicator: function() {
			if (state.livechat.livechatPresence === false || !state.isDesktop) { return; }

			const cmTowerBtn = document.getElementById("cm-tower-btn");
			cmTowerBtn.classList.toggle("online");
		},
		addChannelToTower: function(channel) {
			if (ui.languages[state.language].channels[channel].showChannel === false || !ui.languages[state.language].channels[channel].widgetTitle || !ui.languages[state.language].channels[channel].widgetText || !ui.languages[state.language].channels[channel].link || !ui.languages[state.language].channels[channel].qrCode) { return; }

			const towerBtnWrapper = document.getElementById("cm-tower-btn-wrapper");

			let btn;
			if (state.isDesktop) {
				btn = document.createElement('div');
				btn.addEventListener("click", function (e) {
					const title = ui.languages[state.language].channels[channel].widgetTitle;
					const qrcode = ui.languages[state.language].channels[channel].qrCode;
					const text = ui.languages[state.language].channels[channel].widgetText;
					const serviceHoursText = ui.languages[state.language].channels[channel].serviceHoursText;
					const url = ui.languages[state.language].channels[channel].link;
					const backgroundColor = window.getComputedStyle(e.currentTarget).getPropertyValue("background-color");
					fn.openCustomForm(title, qrcode, text, serviceHoursText, url, backgroundColor);
					fn.closeTower();
					fn.addCloseWidgetButton(true);
				});
			} else {
				btn = document.createElement('a');
				btn.setAttribute('href', ui.languages[state.language].channels[channel].link);
				btn.addEventListener("click", function () {
					fn.closeTower();
				});
			}
			btn.setAttribute('id', "cm-tower-action-" + channel);
			btn.setAttribute('target', '_blank');
			btn.className = ('cm-tower-action ' + channel);

			if (ui.settings.showResponseTimePerChannel === true && ui.languages[state.language].channels[channel].responseTime) {
				btn.innerHTML = fn.addLabel(ui.languages[state.language].labels.responseWithin + ' ' + ui.languages[state.language].channels[channel].responseTime);
			}

			towerBtnWrapper.appendChild(btn);
		},
		buildPhone: function() {
			if (ui.languages[state.language].channels.phone.showChannel === false || !ui.languages[state.language].channels.phone.phoneNumber) { return; }

			const towerBtnWrapper = document.getElementById("cm-tower-btn-wrapper");
			let btn;
			if (state.isDesktop) {
				btn = document.createElement('div');
				btn.addEventListener("click", function () {
					fn.addCloseWidgetButton();
					fn.closeTower();
					__robin.show('phone');
				});
			} else {
				btn = document.createElement('a');
				btn.setAttribute('href', 'tel:' + ui.languages[state.language].channels.phone.phoneNumber);
				btn.addEventListener("click", function () {
					fn.addCloseWidgetButton();
					fn.closeTower();
				});
			}
			btn.setAttribute('id', "cm-tower-action-phone");
			btn.className = ('cm-tower-action phone');

			if (ui.settings.showResponseTimePerChannel === true && ui.languages[state.language].channels.phone.responseTime) {
				btn.innerHTML = fn.addLabel(ui.languages[state.language].labels.responseWithin + ' ' + ui.languages[state.language].channels.phone.responseTime);
			}

			towerBtnWrapper.appendChild(btn);			
		},
		buildCustomBtns: function() {
			if (!ui.languages[state.language].customLinks.length > 1) {return;}

			const towerBtnWrapper = document.getElementById("cm-tower-btn-wrapper");
			var itemToAppend = function (url, iconUrl, label) {
				const btn = document.createElement('a');
				btn.setAttribute('href', url);
				btn.style.backgroundImage="url('" + iconUrl + "')";
				btn.className = ('cm-tower-action custom');
				if (label) {
					btn.innerHTML = fn.addLabel(label);
				}

				return btn;
            };
			
			ui.languages[state.language].customLinks.forEach(function (item, index) {
				if (!item.link || !item.iconUrl || !item.label) { return; }
				towerBtnWrapper.appendChild(itemToAppend(item.link, item.iconUrl, item.label));
			});
		},
		buildChatBtn: function() {
			if (ui.languages[state.language].channels.chatAndContactForm.showChannel === false) {
				state.rbnWidgetLoaded = true;
				return;
			}

			const towerBtnWrapper = document.getElementById("cm-tower-btn-wrapper");

			if (ui.languages[state.language].channels.chatAndContactForm.splitChatAndContactForm === true) {
				let contactFormBtn = document.createElement('div');
				contactFormBtn.setAttribute('id', "cm-tower-action-contact-form");
				contactFormBtn.className = ('cm-tower-action mail');
				contactFormBtn.addEventListener("click", function () {
					fn.addCloseWidgetButton();
					fn.closeTower();
					__robin.show('contact_form');
				});

				if (ui.settings.showResponseTimePerChannel === true && ui.languages[state.language].channels.chatAndContactForm.responseTimeContactForm) {
					contactFormBtn.innerHTML = fn.addLabel(ui.languages[state.language].labels.responseWithin + ' ' + ui.languages[state.language].channels.chatAndContactForm.responseTimeContactForm);
				}

				towerBtnWrapper.insertBefore(contactFormBtn, towerBtnWrapper.firstChild);

				if (state.livechat.livechatPresence === true) {
					let chatBtn = document.createElement('div');
					if (state.livechat.chatAvatar != null){
						chatBtn.innerHTML = '<img class="avatar" src="' + state.livechat.chatAvatar + '"/>';
					} else {
						chatBtn.innerHTML = '<img class="icon" src="' + ui.settings.mainBtnIcon + '"/>';
					}
					chatBtn.setAttribute('id', "cm-tower-action-chat");
					chatBtn.className = ('cm-tower-action chat');
					chatBtn.addEventListener("click", function () {
						fn.addCloseWidgetButton();
						fn.closeTower();
						if (state.livechat.chatEmailAddress){
							__robin.chat(state.livechat.chatEmailAddress);
						} else {
							__robin.show('chat');
						}
					});

					if (ui.settings.showResponseTimePerChannel === true && ui.languages[state.language].channels.chatAndContactForm.responseTimeChat) {
						chatBtn.innerHTML += fn.addLabel(ui.languages[state.language].labels.responseWithin + ' ' + ui.languages[state.language].channels.chatAndContactForm.responseTimeChat);
					}

					towerBtnWrapper.insertBefore(chatBtn, towerBtnWrapper.firstChild);
				}
			} else {
				const btn = document.createElement('div');
				btn.setAttribute('id', "cm-tower-action-chat-contact-form");

				if (state.livechat.livechatPresence === true) {
					btn.className = ('cm-tower-action chat');
					if (state.livechat.chatAvatar != null){
						btn.innerHTML = '<img class="avatar" src="' + state.livechat.chatAvatar + '"/>';
					} else {
						btn.innerHTML = '<img class="icon" src="' + ui.settings.mainBtnIcon + '"/>';
					}
					btn.addEventListener("click", function () {
						fn.addCloseWidgetButton();
						fn.closeTower();
						if (state.livechat.chatEmailAddress){
							__robin.chat(state.livechat.chatEmailAddress);
						} else {
							__robin.show('chat');
						}					});

					if (ui.settings.showResponseTimePerChannel === true && ui.languages[state.language].channels.chatAndContactForm.responseTimeChat) {
						btn.innerHTML += fn.addLabel(ui.languages[state.language].labels.responseWithin + ' ' + ui.languages[state.language].channels.chatAndContactForm.responseTimeChat);
					}
				}
				else {
					btn.className = ('cm-tower-action mail');
					btn.addEventListener("click", function () {
						fn.addCloseWidgetButton();
						fn.closeTower();
						__robin.show('contact_form');
					});

					if (ui.settings.showResponseTimePerChannel === true && ui.languages[state.language].channels.chatAndContactForm.responseTimeContactForm) {
						btn.innerHTML = fn.addLabel(ui.languages[state.language].labels.responseWithin + ' ' + ui.languages[state.language].channels.chatAndContactForm.responseTimeContactForm);
					}
				}

				towerBtnWrapper.insertBefore(btn, towerBtnWrapper.firstChild);
			}

			if (state.livechat.livechatPresence === true) {
				const towerBtnLabel = document.getElementById("cm-tower-btn");
				towerBtnLabel.className += " online";
			}

			state.rbnWidgetLoaded = true;
		},
		appendChildBtns: function() {
			fn.buildPhone();
			fn.addChannelToTower("messenger");
			fn.addChannelToTower("whatsapp");
			fn.buildCustomBtns();
		},
		showTowerBtn: function() {
			const btn = document.getElementById("cm-tower-btn");
			if (btn && !btn.classList.contains("visible")) {
				btn.classList.add("visible");
			}
			state.loading = false;
			clearInterval(state.checkLoadingState);
		},
		addLabel: function(string) {
			let label = '<span class="cm-tower-label">' + string + '</span>';
			return label;
		},
		autofillRobinUser: function() {
			let wpRobinuser = {};
			if (!wpRobinuser.name || !wpRobinuser.email) {
					return;
			}
			var ws = __robin.getWebStore();
			ws.conversationTemplate.useAnonymousChat = true;
			__robin.setShopper(wpRobinuser.email, wpRobinuser.name);
		},
	};

	tower.GetChatAndContactFormSettings = {
		animateTab: false,
		callback: function(event, data) {        	
			if (event == 'user' && data) {
				state.livechat.chatAvatar = data.avatar128;
				state.livechat.chatEmailAddress = data.email;
				state.livechat.livechatPresence = true;
				
				fn.buildChatBtn();
			}
			if (event == 'init') {
				if (state.livechat.livechatPresence === false) {
					const onlineUsers = [];		
					const webstoreUsers = __robin.getWebStoreUsers();
		
					for (var i = 0; i < webstoreUsers.length; i++) {
						if (webstoreUsers[i].actualPresence == 'online'){
							onlineUsers.push(webstoreUsers[i]);
						}
					}

					if (onlineUsers.length >= 1) {
						state.livechat.livechatPresence = true;
					}

					fn.buildChatBtn();
					fn.autofillRobinUser();
				}

				if (ui.settings.positionTowerOnDesktop === "left" || ui.settings.positionTowerOnDesktop === "right") {
					const popover = document.getElementById('robin_popover');
					popover.classList.add(ui.settings.positionTowerOnDesktop);
				}

				// check widget state
				const widgetOpen = sessionStorage.getItem('rbn_displaystate');
				const channel = sessionStorage.getItem('rbn_channel');
				if (widgetOpen == 'on' && (channel === 'chat' || channel === 'contact_form')) {
					fn.toggleOnlineIndicator();
					fn.addCloseWidgetButton();
				} else {
					__robin.hide();
					
					// Open tower automatically on desktop if widget is closed
			        if(ui.settings.openTowerAutomaticallyOnDesktop && state.isDesktop) {
				        setTimeout(function() {
					        const button = document.getElementById("cm-tower-checkbox");
							button.checked = true;
						}, ui.settings.durationOpeningTowerAutomatically)
			        }
			        
			        // Open tower automatically on mobile if widget is closed
			        if(ui.settings.openTowerAutomaticallyOnMobile && !state.isDesktop) {
				        setTimeout(function() {
					        const button = document.getElementById("cm-tower-checkbox");
							button.checked = true;
						}, ui.settings.durationOpeningTowerAutomatically)
			        }
				}
			}
		}
    };

	function initTowerBtn() {
		let documentLang = document.documentElement.lang.substring(0, 2);
		if (!documentLang) {
			documentLang = document.getElementsByTagName('html')[0].getAttribute('xml:lang');
		}
		let language;
		if (ui.languages.hasOwnProperty(documentLang)) {
			state.language = documentLang;
		} else {
			state.language = Object.keys(ui.languages)[0];
		}

		let root = document.documentElement;
		Object.keys(ui.colors).forEach(key => {
			root.style.setProperty('--cmTower' + key, ui.colors[key]);
		});

        fn.isDesktop();
		fn.setupMainElements();
		fn.appendChildBtns();

        state.checkLoadingState = setInterval( function () {
            if (state.rbnWidgetLoaded === true && state.loading === true) {
                fn.showTowerBtn();
            }
        }, 500);
        
        // Show button in case chat/contact form button is still not initiated
        setTimeout( function() {
            if (state.loading === true) {
                fn.showTowerBtn();
            }
        }, 4000);
	}

	return tower;
})();

CM.Tower.Init();
var robin_settings = CM.Tower.GetChatAndContactFormSettings;